import vAnnounce from "./v-announce.vue";
import vAnnounceStep from "./v-announce-step.vue";

export default Vue => {
  Vue.component("v-announce", vAnnounce);
  Vue.component("v-announce-step", vAnnounceStep);
};
